export default __webpack_public_path__ + "static/media/next.1f2a03a6.svg";